import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Geocode from "react-geocode";

const containerStyle = {
    position: "relative",
    minWidth: "100%",
    height: "50VH",
    minHeight: 250,
};
export class InfoWindowEx extends Component {
    constructor(props) {
        super(props);
        this.infoWindowRef = React.createRef();

        if (!this.containerElement) {
            this.containerElement = document.createElement(`div`);
        }
    }

    onInfoWindowOpen = () => {
        ReactDOM.render(
            React.Children.only(this.props.children),
            this.containerElement
        );
        this.infoWindowRef.current.infowindow.setContent(this.containerElement);
    };
    render() {
        return (
            <InfoWindow
                onOpen={this.onInfoWindowOpen}
                ref={this.infoWindowRef}
                {...this.props}
            />
        );
    }
}

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            rep: false,
            activeMarker: {},
            selectedPlace: {},
        };
        Geocode.setApiKey("AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU");
    }
    getMarkers = (qrs) => {
        // const {qrs}=this.props;
        if (qrs)
            return qrs.map((qr, i) => {
                let qrProfile = qr;
                return (
                    <Marker
                        key={i}
                        title={qrProfile.description}
                        position={{
                            lat: qrProfile.location_lat,
                            lng: qrProfile.location_lon,
                        }}
                        name={qrProfile.name}
                        onClick={(props, marker, e) => {
                            let rep = {
                                title: qrProfile.description,
                                name: qrProfile.name,
                                status: qrProfile.status,
                                serviceperiod: qrProfile.service_period,
                                dateoflastservice: qrProfile.date_last_service,
                                dateoflastexamination:
                                    qrProfile.date_last_examination,
                                qrcodeurl: qrProfile.qr_code_url,
                                photo: qrProfile.photo_url,
                            };

                            this.setState({
                                selectedCoord: {
                                    lat: qrProfile.location_lat,
                                    lng: qrProfile.location_lon,
                                },
                                selectedPlace: props,
                                activeMarker: marker,
                                showingInfoWindow: true,
                                rep,
                                // link: linkTo
                            });
                        }}
                    />
                );
            });
        else return [];
    };
    render() {
        const { qrs } = this.props;

        return (
            <div
                ref={"map"}
                style={{ marginTop: 24, width: "100%", height: "100%" }}
            >
                <Map
                    style={{
                        border: "1px solid rgb(195, 207, 214)",
                        minWidth: "100%",
                    }}
                    google={this.props.google}
                    initialCenter={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908,
                              }
                    }
                    zoom={9}
                    center={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908,
                              }
                    }
                    containerStyle={containerStyle}
                    onClick={() => {
                        if (this.state.showingInfoWindow) {
                            this.setState({
                                showingInfoWindow: false,
                                activeMarker: null,
                            });
                        }
                    }}
                >
                    {this.getMarkers(qrs)}
                    <InfoWindowEx
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: 20,
                                padding: 10,
                                width: "100%",
                            }}
                        >
                            <p>
                                <b>Description:</b> {this.state.rep.title || ""}
                            </p>
                            <p>
                                <b>Name:</b> {this.state.rep.name || ""}
                            </p>
                            <p>
                                <b>Status:</b> {this.state.rep.status || ""}
                            </p>
                            <p>
                                <b>Service Period:</b>{" "}
                                {this.state.rep.serviceperiod || ""}
                            </p>
                            <p>
                                <b>Date Of Last Examination:</b>{" "}
                                {this.state.rep.dateoflastexamination || ""}
                            </p>
                            <p>
                                <b>Date Of Last Service:</b>{" "}
                                {this.state.rep.dateoflastservice || ""}
                            </p>
                            <p>
                                <b>QR Code:</b>{" "}
                                {
                                    <img
                                        alt="qrcode"
                                        src={this.state.rep.qrcodeurl}
                                        style={{
                                            height: 100,
                                            width: 100,
                                        }}
                                    />
                                }
                                <b>Photo:</b>{" "}
                                {
                                    <img
                                        alt="eqp pic"
                                        src={this.state.rep.photo}
                                        style={{
                                            height: 75,
                                            width: 75,
                                        }}
                                    />
                                }
                            </p>
                        </div>
                    </InfoWindowEx>
                </Map>
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU",
})(MapContainer);
